/* tslint:disable */

/**
 */
export class EquipSizing {
    maxWidth?: number;
    idStudyEquipment?: number;
    initWidth?: number;
    initLength?: number;
    initSurface?: number;
    minWidth?: number;
    equipName?: string;
    minLength?: number;
    maxLength?: number;
    minSurf?: number;
    maxSurf?: number;
    disabled?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equip-sizing.ts